<template>
    <v-form @submit.prevent="submit" ref="form">
        <v-card style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">Update Company Details</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    <v-icon >close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>
            <v-card-text>
                <v-layout row wrap> 
                    <v-flex xs12 style="padding: 10px 10px 0px 10px; ">                
                        <v-text-field label="Company Name" 
                            v-model="name" 
                            :rules="[rules.required]"
                            @keyup="errorAdd=false"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="Address (House/Building No, Street, Village, Barangay)" 
                            v-model="address" 
                            :rules="[rules.required]"
                            @keyup="errorAdd=false"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm5 style="padding: 0px 10px 0px 10px; "> 
                        <v-select
                            label="Province"
                            :items="province_list"
                            :rules="[rules.required]" 
                            item-text="provinceName"
                            item-value="provinceName"
                            :disabled="disabled"
                            v-model="province"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm5 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="City" 
                            v-model="city" 
                            :rules="[rules.required]"
                            @keyup="errorAdd=false"
                            ></v-text-field>  
                    </v-flex>
                    <v-flex xs12 sm2 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="Zip Code" 
                            v-model="zipCode" 
                            mask="####"
                            :rules="[rules.required]"
                            @keyup="errorAdd=false"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm6 style="padding: 0px 10px 0px 10px; ">        
                        <v-select
                            label="Industry"
                            :items="industry_list"
                            :rules="[rules.required]" 
                            item-text="name"
                            item-value="id"
                            :disabled="disabled"
                            v-model="industryId"
                        ></v-select>
                    </v-flex>
                    <v-flex xs12 sm3 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="Phone" 
                            v-model="phone" 
                            :rules="[rules.required]"
                            @keyup="errorAdd=false"
                            ></v-text-field>  
                    </v-flex>
                    <v-flex xs12 sm3 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="Cellphone" 
                            v-model="cellphone" 
                            :rules="[rules.required]"
                            @keyup="errorAdd=false"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 sm4 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="Company Tax Identification No. (TIN)"
                            v-model="companyTIN"
                            :rules="[rules.tin]"
                            :disabled="disabled"
                            mask="###-###-###"
                            @keyup="error=false"></v-text-field> 
                    </v-flex>
                    <v-flex xs12 sm4 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="Branch Code"
                            v-model="branchCode"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            maxlength="5"
                            @keyup="error=false"></v-text-field> 
                    </v-flex>
                    <v-flex xs12 sm4 style="padding: 0px 10px 0px 10px; ">                
                        <v-text-field label="RDO"
                            v-model="rdo"
                            :rules="[rules.required]"
                            :disabled="disabled"
                            maxlength="5"
                            @keyup="error=false"></v-text-field> 
                    </v-flex>
                </v-layout>  
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions style="height:45px">
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :loading="loading" style="color:white">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import companyApi from '@/api/company'
import timezoneApi from '@/api/timezones' //rename to geography

export default {
    name: 'AddEditCompanyDetails',
    data () {
        return {
            loading: false,
            disabled: false,
            error: false,
            errorMessage: null,
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
                tin: value => {
                    const pattern = /\d{3}\d{3}\d{3}/
                    return pattern.test(value) || 'Invalid Tax Identifacation No.'
                },
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    }
            },
            name: null,
            address: null,
            companyTIN: null,
            remarks: "",
            phone: null,
            cellphone: null,
            city: null,
            province: null,
            zipCode: null,
            branchCode: null,
            rdo: null, //future update - convert this to list so that users can just select
            industryId: null,
            province_list: [],
            industry_list: []
        }
    },
    methods: {
        async setParams(data) {
            if (this.province_list.length==0) await this.getProvinces()
            if (this.industry_list.length==0) await this.getIndustries()

            this.name = data.name
            this.address = data.address
            this.companyTIN = data.companyTIN
            this.phone = data.phone
            this.cellphone = data.cellphone
            this.city = data.city
            this.province = data.province
            this.industryId = data.industryId
            this.zipCode = data.zipCode
            this.branchCode = data.branchCode
            this.rdo = data.rdo
        },
        closeDialog() {
           this.$emit('update:dialogAddEdit', false)
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
            this.errorMessage = ''
        },
        async submit() {
            try {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    var data = {
                        name: this.name,
                        address: this.address,
                        companyTIN: this.companyTIN,
                        phone: this.phone,
                        cellphone: this.cellphone,
                        city: this.city,
                        province: this.province,
                        zipCode: this.zipCode,
                        branchCode: this.branchCode,
                        rdo: this.rdo,
                        industryId: this.industryId,
                        remarks: this.remarks
                    }
                    const response = await companyApi.update(data)
                    if (response.status == 200) {
                        this.$emit('send', null);
                        this.closeDialog()
                    }
                    this.loading = false
                }
            }catch(error) {
                this.error = true
                this.errorMessage = error
                this.loading = false
            }
        },
        async getProvinces() {
            try {
                this.loading = true
                const response = await timezoneApi.getProvinces()
                if (response && response.status==200) {
                    this.province_list = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getIndustries() {
            try {
                this.loading = true
                const response = await companyApi.getIndustries()
                if (response && response.status==200) {
                    this.industry_list = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {},
    computed: {},
  }
</script>